import React, {useState} from 'react';
import {
  Container,
  Row
} from 'react-bootstrap';
import '../../assets/css/pages/form.css';
import '../../assets/css/pages/login.css?v=1';
// import {LoaderMedium} from './../../components/loader';
// import ValidationHelper from '../../helper/validation';
//Axios Call
// import {error_api_call} from '../../actions/action-creators/common';
import {SetMetaData} from './../../helper/page-title';
// import { alertResponseMessage } from '../../actions/action-creators/response';
import {NominateClgBtn} from './../../components/signup/button';

const PortFellowship = () => {
  SetMetaData("Fellowship", "", "");
  // const [schoolFields, setSchoolFields] = useState({email: '', nominate_type: 'email'});
  // const [isFormProcess, setFormProcess] = useState({school: false, student: false});
  // const [isSuccessMsg, setIsSuccess] = useState(false);
  //Update Input Box
  // const _onChangeText = (attrName, value) => {
  //   try{
  //     let fields = {...schoolFields};
  //     value = value.replace(/ /g, '');
  //     fields[attrName] = value;
  //   //   if(form_type === 'student'){
  //   //     setFields({...fields});
  //   //   }else{
  //       setSchoolFields({...fields});
  //   //   }
  //   }catch(error){
  //     error_api_call({error: `portfolio/fellowship|_onChangeText|${attrName},${value}|${error}`});
  //   }
  // }
  //Nominate School
  // const _nominateSchool = async(e) => {
  //   try{
  //     e.preventDefault();
  //     //Validate
  //     if(!schoolFields.email){ 
  //       alertResponseMessage({alert_type: 2, message: "Enter your Principal’s Email"});
  //     }else{
  //       var validators = {};
  //       validators['email'] = 'required|email|min:7|max:100';
  //       const validation = ValidationHelper.validation(schoolFields, validators).error;
  //       if(validation.length){
  //         alertResponseMessage({alert_type: 2, message: "Enter valid Email"});
  //       }else{
  //         setFormProcess({...isFormProcess, school: true});
  //         const emailCheck = await post_api_call('nominate-school', schoolFields);
  //         if(emailCheck.status === 200){
  //           setIsSuccess(true);
  //           window.location.href = `school/nomination?email=${schoolFields.email}&redirect_uri=https://ifspd.eu/fellowships`;
  //           //Open Mail Box
  //           // var linkMail = `mailto:secretariat@ifspd.eu?subject=Nominating School for IFSPD Europe Fellowships&body=Please fill the following details and click send -\nYour name:\nYour designation:\nYour school name:\nCity of your School:\nYour phone number:\n`;
  //           // linkMail = encodeURI(linkMail);
  //           // window.open(linkMail, 'email', "");
  //         }else{
  //           alertResponseMessage({alert_type: 2, message: "Error Processing your Request! Please try after some times"});
  //         }
  //         setFormProcess({...isFormProcess, school: false})
  //       }
  //     }
  //   }catch(error){
  //     alertResponseMessage({alert_type: 2, message: "Error Processing your Request! Please try after some times"});
  //     error_api_call({error: `portfolio/fellowship|_nominateSchool|${error}`});
  //   }
  // }

  return (
    <main id="main">
    <div className="c-app c-default-layout align-items-center fellowship-pg signup-form">
      <Container style={{minHeight: '66vh'}}>
        <Row className="justify-content-center pt-4">
            <h1>Launchpad for the Top 10%</h1>
            <p className="head-about">In today’s volatile and uncertain world, only those with advanced global skills thrive. The IFSPD Europe Fellowship handpicks the top 10% of students from 10 elite schools and amplifies their impact.</p>
            {/* Banner */}
            <div className="row">
                <div className="col-12 col-md-6 box-input order-1 order-md-0">
                <div className="box-1">
                    <ul>
                        <li>
                            <img src={require("../../assets/images/icon/suitcase.png")} alt="Suitcase" />
                            <p>Leadership, diplomacy, international relations & entrepreneurship. Global summits, CEO sessions & mentorship.</p>
                        </li>
                        <li>
                            <img src={require("../../assets/images/icon/check.png")} alt="Endorsement" />
                            <p>50%+ gain admissions to top colleges.</p>
                        </li>
                        <li>
                            <img src={require("../../assets/images/icon/global.png")} alt="Glboal" />
                            <p>Alumni include UN heads, Civil Servants, CEOs & innovators.</p>
                        </li>
                    </ul>
                </div>
                </div>
                <div className="col-12 col-lg-6 order-3 order-md-3">
                {/* {isSuccessMsg
                    ?
                    <div className="alert alert-success mt-2">
                      <strong>Thank you for nominating your School.</strong>
                    </div>
                    :
                    <div className="input-email">
                        <div className="d-flex">
                            <input
                            name="principal_email"
                            type="email" 
                            placeholder="Principal’s email"
                            value={schoolFields.email}
                            onChange={(event) => _onChangeText('email', event.target.value)}
                            />
                            <button
                            onClick={(e) => _nominateSchool(e)}
                            disabled={isFormProcess.school}
                            >
                            {isFormProcess.school && (
                                <><LoaderMedium size={10} />&nbsp;</>
                            )}
                            Nominate Your School
                            </button>
                        </div>
                    </div>
                } */}
                  <NominateClgBtn />
                </div>
                <div className="col-12 col-md-6 box-2 order-0 order-md-1">
                    <img src={require("../../assets/images/bg/fellowship.jpg")} alt="Background" />
                </div>
            </div>
            {/* Feature */}
            <section>
            <div className="col-12 col-md-12 text-center">
                <h2>Reserved for the Top Students to Unlock Global Opportunities & Stand Out from the Crowd</h2>
                <div className="row">
                    <div className="col-12 col-md-4">
                        <div className="feature">
                            <p>Higher order, multi-dimensional,  capacity building for all career paths - STEM & liberal</p>
                            <a href="#application_form">School Application <i className="fa fa-chevron-right"></i></a>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="feature">
                            <p>Tailor made mentoring & CEO Shadowing - to build skills that top colleges  value</p>
                            <a href="#application_form">School Application <i className="fa fa-chevron-right"></i></a>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="feature">
                            <p>Unlock exclusive global opportunities - fellowships, internships & scholarships</p>
                            <a href="#application_form">School Application <i className="fa fa-chevron-right"></i></a>
                        </div>
                    </div>
                    <div className="col-12 col-md-12 logo-con justify-content-around mt-2 mt-sm-4 mb-3 mb-sm-5">
                        <img src={require("../../assets/images/logo/unesco.png")} alt="UNESCO" />
                        <img src={require("../../assets/images/logo/davos.png")} alt="Davos Worldwide" />
                        <img src={require("../../assets/images/logo/cop16.png")} alt="COP16 Colombia" />
                        <img src={require("../../assets/images/logo/paris.png")} alt="Paris Collaborative" />
                        <img src={require("../../assets/images/logo/kectil.png")} alt="Kectil" />
                    </div>
                    <p className="fs-3 fw-lighter mb-0">IFSPD Europe handpicks students to represent their nations as speakers at global summits like the UN Sustainability Conference and Davos Worldwide—alongside world leaders. Selected students gain access to prestigious fellowships such as Kectil and Paris Collaborative.</p>
                </div>
            </div>
            </section>
            {/* Tolls */}
            <section>
                <div className="col-12 col-md-12 toll-sec">
                <h2 className="text-center">Higher Order Continuous Capacity Building for All Career Paths - STEM, Liberal & Management</h2>
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8">
                        <img src={require("../../assets/images/bg/fellow-level.JPG")} alt="fellowship" />
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10">
                        <div className="row mt-3 level-sec">
                            <div className="col-12 col-md-4 d-flex mb-3">
                                <img src={require("../../assets/images/icon/recycle.jpg")} alt="Global Sustainability" />
                                <p><b>Global Sustainability Councils:</b> Harvard case studies. UN SDGs.</p>
                            </div>
                            <div className="col-12 col-md-4 d-flex mb-3">
                                <img src={require("../../assets/images/icon/check.png")} alt="Achievements" />
                                <p><b>PortAhead:</b> Track & showcase achievements & certificates</p>
                            </div>
                            <div className="col-12 col-md-4 d-flex mb-3">
                                <img src={require("../../assets/images/icon/flag.jpg")} alt="Mentorship" />
                                <p><b>Mentorship:</b> Personal & academics - applications, SOPs</p>
                            </div>
                            <div className="col-12 col-md-4 d-flex mb-3">
                                <img src={require("../../assets/images/icon/play.jpg")} alt="Social Start-up" />
                                <p><b>Social Start-up:</b> Innovate & create with KPIs & SDGs</p>
                            </div>
                            <div className="col-12 col-md-4 d-flex mb-3">
                                <img src={require("../../assets/images/icon/sustainability.jpg")} alt="Sustainability" />
                                <p><b>Sustainability Summit:</b> Grand finale diplomatic summit</p>
                            </div>
                            <div className="col-12 col-md-4 d-flex mb-3">
                                <img src={require("../../assets/images/icon/earth.jpg")} alt="Global" />
                                <p><b>Global Opportunities:</b> CXO shadowing, summits, internship</p>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </section>
            {/* School Logo */}
            <section className="text-center row justify-content-center">
                <h2>10 Schools Handpicked Annually - To Elevate their Top Students’ to the Global Stage</h2>
                <div className="col-12 col-lg-9">
                  <div className="row">
                  <div className="col-12 col-md-12 logo-con logo-school justify-content-around">
                      <img src={require("../../assets/images/school/The-Lawrence-School.jpeg")} alt="The Lawrence School" />
                      <img src={require("../../assets/images/school/The-Scindia-School.jpg")} alt="The Scindia School" />
                      <img src={require("../../assets/images/school/Delhi-Public-School.jpg")} alt="Delhi Public School" />
                      <img src={require("../../assets/images/school/The-Maurya.jpg")} alt="The Maurya" />
                      <img src={require("../../assets/images/school/MIT-Pune.jpg")} alt="MIT Pune" />
                      <img src={require("../../assets/images/school/Good-Shepherd-International-School.jpg")} alt="Good Shepherd International School" />
                      <img src={require("../../assets/images/school/Welham-Girls-School.jpg")} alt="Welham Girls School" />
                      <img src={require("../../assets/images/school/Manav-Rachna.jpg")} alt="Manav Rachna" />
                      <img src={require("../../assets/images/school/BGS-Knowledge-City.jpg")} alt="BGS Knowledge City" />
                      <img src={require("../../assets/images/school/Future-Hope.jpg")} alt="Future Hope" />
                      <img src={require("../../assets/images/school/Sarala-Birla-Academy.jpg")} alt="Sarala Birla Academy" />
                      <img src={require("../../assets/images/school/Aditya-Birla-World-Academy.jpg")} alt="Aditya Birla World Academy" />
                      <img src={require("../../assets/images/school/Sunbeam-International-School.jpg")} alt="Sunbeam International School" />
                      <img src={require("../../assets/images/school/Millennium-National-School.jpg")} alt="Millennium National School" />
                      <img src={require("../../assets/images/school/Golden-jubilee-school.jpg")} alt="Golden Jubilee School" />
                  </div>
                  </div>
                </div>
                <p className="fs-3 fw-lighter mb-0">Over 50% of our students secure admissions to top colleges with scholarships. Alumni network includes UN leaders, civil servants, CEOs, technologists & business leaders.</p>
            </section>
            {/* Video */}
            <section>
              <div className="row">
                <div className="col-12 col-md-12 col-lg-6 order-2 order-lg-1">
                  <iframe
                    height="315"
                    width="100%"
                    srcDoc={`<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://www.youtube.com/embed/Ymw0v6-LTPE/?autoplay=1><img src=https://i.ytimg.com/vi/Ymw0v6-LTPE/sddefault.jpg alt='IFSPD Europe'><span><svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%"><path class="ytp-large-play-button-bg" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#f00"></path><path d="M 45,24 27,14 27,34" fill="#fff"></path></svg></span></a>`}
                    title="IFSPD Europe"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen>
                    </iframe>
                </div>
                <div className="col-12 col-md-12 col-lg-6 order-1 order-lg-2" id="application_form">
                  <h3 className="text-center text-lg-start">IFSPD Europe Fellowships <br/><span>By Invitation Only.</span></h3>
                  <p className="color-bl1 mb-0 fs-5 fw-bold">Authorities can nominate their schools. Quarterly review of applications. IFSPD Europe is an equal opportunity provider.</p>
                  {/* {isSuccessMsg
                    ?
                    <div className="alert alert-success mt-2">
                      <strong>Thank you for nominating your School.</strong>
                    </div>
                    :
                    <div className="input-email mb-4 mt-0">
                      <div className="d-flex">
                        <input
                          name="principal_email"
                          type="email" 
                          placeholder="Principal’s email"
                          value={schoolFields.email}
                          onChange={(event) => _onChangeText('email', event.target.value)}
                        />
                        <button
                          onClick={(e) => _nominateSchool(e)}
                          disabled={isFormProcess.school}
                        >
                          {isFormProcess.school && (
                            <><LoaderMedium size={10} />&nbsp;</>
                          )}
                          Nominate Your School
                        </button>
                      </div>
                    </div>
                  } */}
                  <NominateClgBtn />
                </div>
            </div>
            </section>
        </Row>
      </Container>
    </div>
    </main>
  )
}

export default PortFellowship
